import { __ } from '@wordpress/i18n';
import { useBlockProps } from '@wordpress/block-editor';

export const edit = ( props ) => {
	const blockProps = useBlockProps();
	return (
		<>
			<div { ...blockProps }>
				<strong>{ __( 'Rating', 'learnpress-course-review' ) }</strong>
				<div className="lp-field-star">
					<div className="lp-course-filter__field">
						<input type="radio"></input>
						{ __( 'All ratings', 'learnpress-course-review' ) }
					</div>
					<div className="lp-course-filter__field">
						<input type="radio"></input>
						<div className="lp-filter-item-star">
							<div className="review-stars-rated">
								<div class="review-star">
									<em class="far lp-review-svg-star">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
									<em class="fas lp-review-svg-star" style={ { width: '100%' } }>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
								</div>
								<div class="review-star">
									<em class="far lp-review-svg-star">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
									<em class="fas lp-review-svg-star" style={ { width: '0%' } }>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
								</div>
								<div class="review-star">
									<em class="far lp-review-svg-star">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
									<em class="fas lp-review-svg-star" style={ { width: '0%' } }>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
								</div>
								<div class="review-star">
									<em class="far lp-review-svg-star">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
									<em class="fas lp-review-svg-star" style={ { width: '0%' } }>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
								</div>
								<div class="review-star">
									<em class="far lp-review-svg-star">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
									<em class="fas lp-review-svg-star" style={ { width: '0%' } }>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
								</div>
							</div>
						</div>
						{ '& up' }
					</div>
					<div className="lp-course-filter__field">
						<input type="radio"></input>
						<div className="lp-filter-item-star">
							<div className="review-stars-rated">
								<div class="review-star">
									<em class="far lp-review-svg-star">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
									<em class="fas lp-review-svg-star" style={ { width: '100%' } }>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
								</div>
								<div class="review-star">
									<em class="far lp-review-svg-star">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
									<em class="fas lp-review-svg-star" style={ { width: '100%' } }>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
								</div>
								<div class="review-star">
									<em class="far lp-review-svg-star">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
									<em class="fas lp-review-svg-star" style={ { width: '0%' } }>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
								</div>
								<div class="review-star">
									<em class="far lp-review-svg-star">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
									<em class="fas lp-review-svg-star" style={ { width: '0%' } }>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
								</div>
								<div class="review-star">
									<em class="far lp-review-svg-star">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
									<em class="fas lp-review-svg-star" style={ { width: '0%' } }>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
								</div>
							</div>
						</div>
						{ '& up' }
					</div>
					<div className="lp-course-filter__field">
						<input type="radio"></input>
						<div className="lp-filter-item-star">
							<div className="review-stars-rated">
								<div class="review-star">
									<em class="far lp-review-svg-star">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
									<em class="fas lp-review-svg-star" style={ { width: '100%' } }>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
								</div>
								<div class="review-star">
									<em class="far lp-review-svg-star">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
									<em class="fas lp-review-svg-star" style={ { width: '100%' } }>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
								</div>
								<div class="review-star">
									<em class="far lp-review-svg-star">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
									<em class="fas lp-review-svg-star" style={ { width: '100%' } }>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
								</div>
								<div class="review-star">
									<em class="far lp-review-svg-star">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
									<em class="fas lp-review-svg-star" style={ { width: '0%' } }>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
								</div>
								<div class="review-star">
									<em class="far lp-review-svg-star">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
									<em class="fas lp-review-svg-star" style={ { width: '0%' } }>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
								</div>
							</div>
						</div>
						{ '& up' }
					</div>
					<div className="lp-course-filter__field">
						<input type="radio"></input>
						<div className="lp-filter-item-star">
							<div className="review-stars-rated">
								<div class="review-star">
									<em class="far lp-review-svg-star">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
									<em class="fas lp-review-svg-star" style={ { width: '100%' } }>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
								</div>
								<div class="review-star">
									<em class="far lp-review-svg-star">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
									<em class="fas lp-review-svg-star" style={ { width: '100%' } }>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
								</div>
								<div class="review-star">
									<em class="far lp-review-svg-star">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
									<em class="fas lp-review-svg-star" style={ { width: '100%' } }>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
								</div>
								<div class="review-star">
									<em class="far lp-review-svg-star">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
									<em class="fas lp-review-svg-star" style={ { width: '100%' } }>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
								</div>
								<div class="review-star">
									<em class="far lp-review-svg-star">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
									<em class="fas lp-review-svg-star" style={ { width: '0%' } }>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											stroke-width="1"
											stroke-linecap="round"
											stroke-linejoin="round"
											class="lucide lucide-star"
										>
											<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
										</svg>
									</em>
								</div>
							</div>
						</div>
						{ '& up' }
					</div>
				</div>
			</div>
		</>
	);
};
